const POST = {
  LOGIN: "login",
  LOGOUT: "logout",
  ADD_CLIENT: "register_user",
  CREATE_ORDER: "create_order",
  UPDATE_ORDER: "update_order",
  UPDATE_ORDER_STATUS: "update_order_status",
  DELETE_ORDER: "delete_order",
  UPLOAD_FILE: "upload_file"
};

const GET = {
  CLIENT_LIST: "get_users_listing",
  DASHBOARD_COUNT: "get_user_dashboard_count",
  ORDER_LIST: "get_orders_listing",
  USER_DETAILS: "get_user",
};

const PUT = {
};

const DELETE = {
  DELETE_CLIENT: "delete_user",
};

export { POST, GET, PUT, DELETE };
